// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claims from './claims';
import {combineReducers} from 'redux';
import createClaimModal from './create-claim';
import searchFilters from './search-filters';
import selectedStatus from './selected-status';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claims,
    createClaimModal,
    searchFilters,
    selectedStatus
});



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/reducers/index.js